
import { Option, button as button_1 } from "../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { filter, tryFind as tryFind_1, item, ofArray, collect, empty, length, tryItem, tail, head, isEmpty, map, contains, singleton, append } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { compare, comparePrimitives, safeHash, equals } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { ofList as ofList_1, FSharpMap__get_Item, tryFind, containsKey } from "../../fable_modules/fable-library-js.5.13.0/Map.js";
import { Wave, WaveSimState, Msg, ComponentGroup } from "../../Model/ModelType.js";
import { interpolate, printf, toFail } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { SimulatedDesign__SheetOfInstance_1A26531, FastSimulation__get_SimulatedCanvasState, FastSimulation__get_ConnectionsByPort, SheetPort, FastSimulation__get_ComponentsById, FastSimulation__get_SimulatedTopSheet, FastSimulation__ComponentOf_6546966D } from "../../Simulator/SimTypes.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.13.0/Option.js";
import { getFastSim, portSheetPort } from "../../Simulator/Simulator.js";
import { MapModule_ValuesL } from "../../Common/EEExtensions.js";
import { List_distinct } from "../../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { topHalfButtonProps } from "./WaveSimStyle.js";
import { Color_IColor_$reflection, Color_IColor } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { viewWaveInfoPopup } from "../UIPopups.js";
import { Record } from "../../fable_modules/fable-library-js.5.13.0/Types.js";
import { record_type, string_type, bool_type } from "../../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { simulatorLabel, circuitCheckIsNeeded } from "../ModelHelpers.js";
import { compareLoadedStates } from "../../Simulator/FastSim/FastExtract.js";
import { tryOfInstanceCached, waveIndexOf, ofInstanceCached } from "../../Simulator/FastSim/PortView.js";
import { warn } from "../../Shared/Log.js";
import { camelCaseDottedWords } from "../../Simulator/FastSim/WaveNames.js";
import { memoizeByIdentity } from "../../Common/Helpers.js";
import { isEmpty as isEmpty_1, contains as contains_1, ofList } from "../../fable_modules/fable-library-js.5.13.0/Set.js";
import { isLibrarySheet } from "../../Interface/ComponentLibraries.js";
import { WaveIndexT } from "../../Common/CommonTypes.js";

/**
 * Helper function to create Bulma buttons
 */
export function button(options, func, label) {
    return button_1(append(options, singleton(new Option(/* OnClick */ 18, [func]))), singleton(label));
}

/**
 * convenience functions
 */
export function isWaveSelected(index, wsModel) {
    return contains(index, wsModel.SelectedWaves, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

export function isRamSelected(ramId_, ramId__1, wsModel) {
    return containsKey([ramId_, ramId__1], wsModel.SelectedRams);
}

export function portBits(n) {
    if (n < 2) {
        return "";
    }
    else {
        return `(${n - 1}:0)`;
    }
}

/**
 * Which group (for selector classification) is a component of this type in?
 * 
 * A function of the component TYPE alone, which is all it ever needed: it took a whole
 * FastSimulation only to look the type up. Callers pass the type, so that when a port carries
 * its own type there is nothing here left to change - and so that this says nothing about where
 * the simulation ran.
 */
export function getCompGroup(compType) {
    switch (compType.tag) {
        case 50:
        case 51:
        case 52:
        case 53:
            return ComponentGroup.InputOutput;
        case 54:
            return ComponentGroup.Buses;
        case 55:
            return ComponentGroup.MuxDemux;
        case 8:
        case 10:
            return ComponentGroup.Gates;
        case 47:
        case 5:
            return ComponentGroup.Buses;
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 9:
            return ComponentGroup.MuxDemux;
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 23:
        case 25:
        case 24:
            return ComponentGroup.Arithmetic;
        case 26:
            return ComponentGroup.CustomComp;
        case 31:
        case 32:
        case 33:
        case 34:
        case 35:
        case 37:
        case 36:
        case 38:
            return ComponentGroup.FFRegister;
        case 39:
        case 40:
        case 41:
        case 42:
            return ComponentGroup.Memories;
        case 6:
        case 27:
        case 29:
        case 28:
        case 30:
            return toFail(printf("Bus select, MergeWires, MergeN, SplitWire should not appear"));
        case 48:
        case 49:
        case 43:
        case 44:
        case 45:
            return toFail(printf("Legacy component types should not appear"));
        case 46:
            return toFail(printf("Shift is an internal-only component which should never appear on the canvas"));
        default:
            return ComponentGroup.InputOutput;
    }
}

/**
 * The heading over a group of components within one sheet of the wave selector.
 * 
 * Every case of ComponentGroup, so that adding one is a compile error rather than a row headed
 * "What? Not used!" - which is what the wildcard this replaces would have given. Three of them,
 * WireLabel, Viewers and Component, are not produced by getCompGroup: they are there for grouping
 * components by type rather than by name, which the selector does not currently do.
 */
export function groupHeading(compGroup) {
    const name = (compGroup.tag === 2) ? "Viewers" : ((compGroup.tag === 0) ? "Wire Labels" : ((compGroup.tag === 3) ? "Buses" : ((compGroup.tag === 4) ? "Logic Gates" : ((compGroup.tag === 5) ? "Multiplexers" : ((compGroup.tag === 6) ? "Arithmetic" : ((compGroup.tag === 8) ? "Flip Flops and Registers" : ((compGroup.tag === 9) ? "RAMs and ROMs" : ((compGroup.tag === 10) ? compGroup.fields[0] : ((compGroup.tag === 7) ? "Custom Components" : "Inputs / Outputs / Labels / Viewers")))))))));
    return name.toLocaleUpperCase();
}

/**
 * Convert Wave list to list of WaveIndexT
 */
export function wavesToIds(waves) {
    return map((wave) => wave.WaveId, waves);
}

/**
 * The name of the sheet a wave's component sits on, which is how ComponentsById and
 * ConnectionsByPort are both keyed.
 * A component's access path names the custom component instances it sits inside, innermost first,
 * so its head is an instance of the sheet wanted. It is that instance's TYPE which names the
 * sheet: its LABEL is chosen by whoever placed it, and only happens to be the sheet's name until
 * someone renames the instance. Asking the label instead left every wave in a renamed subsheet -
 * REGFILE for reg16x8, say - with no connections found, and so no wires highlighted on hover.
 */
export function sheetOfWave(fs, wi) {
    const matchValue = wi.Id[1];
    if (!isEmpty(matchValue)) {
        const option_1 = FastSimulation__ComponentOf_6546966D(fs, [head(matchValue), tail(matchValue)]);
        if (option_1 != null) {
            const matchValue_1 = option_1.FType;
            if (matchValue_1.tag === 26) {
                return matchValue_1.fields[0].Name;
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
    else {
        return FastSimulation__get_SimulatedTopSheet(fs);
    }
}

/**
 * Work out a SheetPort from a wave, if one exists
 * SheetPorts may not exist in some corner cases when simulation is ending etc.
 * 
 * Every step is best effort and gives nothing rather than throwing. The link between a wave and
 * the schematic is only as good as the schematic still being the one that was simulated, and this
 * runs from the mouse handlers on a waveform's name - where an exception is not caught by
 * showWaveforms' error boundary, which has already returned by then.
 */
export function waveToSheetPort(fs, wi) {
    let option_8, sheet, option_6, option_1, comp, option_3, matchValue_1, matchValue_2;
    return defaultArg((option_8 = sheetOfWave(fs, wi), (option_8 != null) ? ((sheet = option_8, (option_6 = ((option_1 = tryFind(sheet, FastSimulation__get_ComponentsById(fs)), (option_1 != null) ? tryFind(wi.Id[0], option_1) : undefined)), (option_6 != null) ? ((comp = option_6, defaultArg((option_3 = tryItem(wi.PortNumber, (matchValue_1 = (length(comp.InputPorts) > 0), (matchValue_2 = (length(comp.OutputPorts) > 0), (wi.PortType.tag === 1) ? (matchValue_1 ? (matchValue_2 ? comp.OutputPorts : comp.InputPorts) : (matchValue_2 ? comp.OutputPorts : empty())) : (matchValue_1 ? comp.InputPorts : (matchValue_2 ? comp.OutputPorts : empty()))))), (option_3 != null) ? singleton(new SheetPort(sheet, option_3)) : undefined), empty()))) : undefined))) : undefined), empty());
}

/**
 * given a SheetPort, get all directly connected SheetPorts
 */
export function connectedPorts(fs, sheetPort) {
    const compMap = FastSimulation__get_ComponentsById(fs);
    const name = sheetPort.Sheet;
    return collect((conn) => {
        let compsWithIds;
        return collect((_arg) => {
            if (_arg != null) {
                return singleton(_arg);
            }
            else {
                return empty();
            }
        }, map((compsWithIds = FSharpMap__get_Item(compMap, name), (port) => portSheetPort(compsWithIds, name, port)), ofArray([conn.Source, conn.Target])));
    }, defaultArg(tryFind(sheetPort, FastSimulation__get_ConnectionsByPort(fs)), empty()));
}

/**
 * given an IOlabel port, get all same-name IOLabels on the same sheet
 */
export function connectedIOs(fs, sp) {
    const comps = FSharpMap__get_Item(FastSimulation__get_ComponentsById(fs), sp.Sheet);
    const matchValue = FSharpMap__get_Item(comps, sp.PortOnComp.HostId);
    if (matchValue.Type.tag === 3) {
        const sheet = sp.Sheet;
        return collect((_arg) => {
            let matchResult;
            if (_arg.Type.tag === 3) {
                if (_arg.Label === matchValue.Label) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const comp1_1 = _arg;
                    return append((length(comp1_1.OutputPorts) > 0) ? singleton(new SheetPort(sheet, item(0, comp1_1.OutputPorts))) : empty(), append((length(comp1_1.InputPorts) > 0) ? singleton(new SheetPort(sheet, item(0, comp1_1.InputPorts))) : empty(), singleton(sp)));
                }
                default:
                    return empty();
            }
        }, MapModule_ValuesL(comps));
    }
    else {
        return singleton(sp);
    }
}

/**
 * Given a list of ports, get all ports connected to any port in it.
 * used by connsOfWave
 */
export function allConnectedPorts(fs_mut, sp_mut) {
    allConnectedPorts:
    while (true) {
        const fs = fs_mut, sp = sp_mut;
        const newSP = List_distinct(collect((sheetPort) => connectedPorts(fs, sheetPort), List_distinct(collect((sp_1) => connectedIOs(fs, sp_1), sp), {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        })), {
            Equals: equals,
            GetHashCode: (x_1) => (safeHash(x_1) | 0),
        });
        const matchValue = (length(newSP) - length(sp)) | 0;
        if (matchValue === 0) {
            return newSP;
        }
        else if (matchValue >= 0) {
            fs_mut = fs;
            sp_mut = newSP;
            continue allConnectedPorts;
        }
        else {
            return newSP;
        }
        break;
    }
}

/**
 * Get all the connections of a given wave signal
 */
export function connsOfWave(fs, wi) {
    return List_distinct(map((conn) => conn.Id, collect((sp_1) => {
        const matchValue = tryFind(sp_1, FastSimulation__get_ConnectionsByPort(fs));
        if (matchValue != null) {
            return matchValue;
        }
        else {
            return empty();
        }
    }, allConnectedPorts(fs, waveToSheetPort(fs, wi)))), {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    });
}

/**
 * button driving a popup with a page of info about waveform simulator
 */
export function waveInfoButton(name, dispatch) {
    return button(topHalfButtonProps(Color_IColor.IsInfo)("RefreshButton")(false), (_arg) => {
        viewWaveInfoPopup(dispatch, name);
    }, name);
}

export class WaveSimButtonOptions extends Record {
    constructor(IsDirty, IsRunning, IsErrored, StartEndMsg, StartEndColor) {
        super();
        this.IsDirty = IsDirty;
        this.IsRunning = IsRunning;
        this.IsErrored = IsErrored;
        this.StartEndMsg = StartEndMsg;
        this.StartEndColor = StartEndColor;
    }
}

export function WaveSimButtonOptions_$reflection() {
    return record_type("WaveSimHelpers.WaveSimButtonOptions", [], WaveSimButtonOptions, () => [["IsDirty", bool_type], ["IsRunning", bool_type], ["IsErrored", bool_type], ["StartEndMsg", string_type], ["StartEndColor", Color_IColor_$reflection()]]);
}

/**
 * end the current simulation
 * 
 * Nothing here clears the schematic. It used to reset the sheet's selection, because that is
 * where the hover highlight had put itself; the highlight is now derived from the viewer's own
 * state and goes with it, and the user's selection is the user's.
 */
export function endButtonAction(canvasState, model, dispatch, ev) {
    return dispatch(Msg.EndWaveSim);
}

/**
 * Whether the waveform viewer has a simulation, running or being started: what the Start button
 * turns on and the End button turns off. Starting sets Loading before its first refresh.
 */
export function waveSimIsActive(model, ws) {
    if (!equals(model.WaveSimSheet, "") && !equals(model.WaveSimSheet, undefined)) {
        if (equals(ws.State, WaveSimState.Success)) {
            return true;
        }
        else {
            return equals(ws.State, WaveSimState.Loading);
        }
    }
    else {
        return false;
    }
}

/**
 * Return info about current state of waveform simulator
 * which is used to switch buttons on/off etc.
 * 
 * Runs on every render of the wave sim panel, so nothing here works out anything about the design
 * that the model has already been told.
 */
export function getWaveSimButtonOptions(canv_, canv__1, model, ws, dispatch) {
    const canv = [canv_, canv__1];
    const fs = getFastSim();
    const simExists = !equals(model.WaveSimSheet, "") && !equals(model.WaveSimSheet, undefined);
    const success = equals(ws.State, WaveSimState.Success) ? true : equals(ws.State, WaveSimState.Loading);
    if (circuitCheckIsNeeded(model, canv[0], canv[1])) {
        dispatch(Msg.RequestCircuitCheck);
    }
    let hasSimErr;
    const matchValue = model.CircuitCheck.Verdict;
    let matchResult;
    if (matchValue != null) {
        if (matchValue[0].tag === 1) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            hasSimErr = true;
            break;
        }
        default:
            hasSimErr = false;
    }
    const errored = hasSimErr ? true : (ws.State.tag === 3);
    const running = (success ? true : errored) && simExists;
    const isDirty = (((simExists && running) && !compareLoadedStates(fs, canv[0], canv[1], model.CurrentProj)) && equals(model.UIState, undefined)) && !model.IsLoading;
    const patternInput = running ? ["EndSimulation" + simulatorLabel(model), Color_IColor.IsDanger] : (errored ? ["View Problems", Color_IColor.IsWarning] : ["Start Simulation" + simulatorLabel(model), Color_IColor.IsSuccess]);
    return new WaveSimButtonOptions(isDirty, running, errored, patternInput[0], patternInput[1]);
}

/**
 * The Wave record for one selected wave: its name, its width, and where its data lies.
 * 
 * Built from the ports of the wave's own INSTANCE - `PortView.ofInstance`, which costs one sheet
 * - and from the design, which supplies everything about where the wave sits. What the simulation
 * is asked for is the two things only it knows: the port's width, and its driver.
 * 
 * A wave whose port the simulation no longer offers gets a record saying so rather than throwing.
 * It is what a selection saved against an older version of the design resolves to, and
 * reconcileWaves drops it moments later; failing here instead took the whole viewer down.
 */
export function makeWave(ws, fastSim, wi) {
    const patternInput = wi.Id;
    const instance = patternInput[1];
    const view = ofInstanceCached(fastSim, instance);
    const port = tryFind_1((p) => {
        if (equals(p.PortComp, patternInput[0]) && equals(p.PortIs, wi.PortType)) {
            return p.PortNum === wi.PortNumber;
        }
        else {
            return false;
        }
    }, view.ViewPorts);
    if (port != null) {
        const port_1 = port;
        if (port_1.PortWidth === 0) {
            warn(`zero-width driver for ${port_1.PortCompLabel}.${interpolate("%A%P()", [wi.PortType])}[${wi.PortNumber}]`);
        }
        return new Wave(wi, instance, view.ViewSubSheet, port_1.PortDisplayName, (camelCaseDottedWords(view.ViewSheet) + ".") + port_1.PortDisplayName, port_1.PortCompLabel, port_1.PortLabel, port_1.PortWidth, port_1.PortDriver);
    }
    else {
        warn(`no port for ${interpolate("%A%P()", [wi.PortType])}[${wi.PortNumber}] of a component in ${view.ViewSheet}`);
        return new Wave(wi, instance, empty(), "?", "?", "?", "?", 0, wi.SimArrayIndex);
    }
}

export const librarySheetsOf = memoizeByIdentity((fs) => ofList(map((ldc_1) => ldc_1.Name, filter(isLibrarySheet, FastSimulation__get_SimulatedCanvasState(fs))), {
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
}));

/**
 * True when the component sits inside an instance of a library sheet.
 * A library component is opaque: its innards are no more offered here than its sheet is offered
 * in the Sheets menu. The instance's own ports are unaffected - they belong to the sheet it was
 * placed on, and appear like any other custom component's, as sheet.L<n>_Comp1.port.
 * AccessPath is the chain of custom component instances the component sits within, so the test
 * is whether any of them is an instance of a library sheet.
 * 
 * The selector does not need this: the hierarchy it draws already makes a library component
 * opaque, so no instance inside one is ever on show. It is for the two places that reach a
 * component without going through the hierarchy - the default selection, which looks for Viewers
 * anywhere in the design, and the schematic's right-click menu.
 */
export function isInsideLibraryComponent(fs, _arg) {
    const librarySheets = librarySheetsOf(fs);
    const entersLibrary = (ap_1_mut) => {
        entersLibrary:
        while (true) {
            const ap_1 = ap_1_mut;
            if (!isEmpty(ap_1)) {
                if (contains_1(SimulatedDesign__SheetOfInstance_1A26531(fs.Design, ap_1), librarySheets)) {
                    return true;
                }
                else {
                    ap_1_mut = tail(ap_1);
                    continue entersLibrary;
                }
            }
            else {
                return false;
            }
            break;
        }
    };
    if (!isEmpty_1(librarySheets)) {
        return entersLibrary(_arg);
    }
    else {
        return false;
    }
}

/**
 * The ports of one elaborated component that carry a waveform, as wave indices into the
 * simulation as it is now. Read off the instance's port view - the one derivation of what
 * carries a wave - rather than deciding again from a FastComponent.
 */
export function waveIndicesOfFComp(fs, fId_, fId__1) {
    const fId_1 = [fId_, fId__1];
    const ap = fId_1[1];
    return map((port) => waveIndexOf(ap, port), filter((p) => equals(p.PortComp, fId_1[0]), ofInstanceCached(fs, ap).ViewPorts));
}

/**
 * The wave one index names, in the simulation as it is NOW - or None if that simulation does not
 * offer it any more.
 * 
 * A WaveIndexT says where its data lies (SimArrayIndex) as well as which port it is. The first is
 * true only of the build it came from, so a selection made before a rebuild has to be resolved
 * against the new one. The other three fields are the stable name and are what this looks up.
 * 
 * It used to be answered by indexing a map of every wave in the simulation, built by inverting
 * that map's 208,896 keys. The component knows where its own ports are, so a selection of a
 * hundred waves is a hundred lookups.
 * None drops the wave. That is said only by an instance that HAS been described and does not
 * offer the port - a component renamed or deleted. An instance not yet described (the sidecar
 * has not answered for it) keeps the wave, unresolved: SimArrayIndex = DriverIndex -1, which nothing draws
 * and nothing fetches, until the slice lands and the next refresh resolves it - or drops it
 * then, knowing.
 */
export function reResolveWave(fs, wi) {
    const patternInput = wi.Id;
    const matchValue = tryOfInstanceCached(fs)(patternInput[1]);
    if (matchValue != null) {
        const option_1 = tryFind_1((p) => {
            if (equals(p.PortComp, patternInput[0]) && equals(p.PortIs, wi.PortType)) {
                return p.PortNum === wi.PortNumber;
            }
            else {
                return false;
            }
        }, matchValue.ViewPorts);
        if (option_1 != null) {
            return new WaveIndexT(option_1.PortArrayIndex, wi.Id, wi.PortType, wi.PortNumber);
        }
        else {
            return undefined;
        }
    }
    else {
        return new WaveIndexT(-1, wi.Id, wi.PortType, wi.PortNumber);
    }
}

/**
 * Build a wave map in a scope that holds nothing.
 * 
 * This exists because a Fable map carries the comparer it was built with, and Fable creates that
 * comparer - an object holding a Compare closure - at the construction site. V8 gives all the
 * closures of a function one shared context holding every variable any of them captures, so a
 * comparer made where a FastSimulation is in scope shares a context with it - and the map then
 * pins the whole simulation, step arrays and all, for as long as the map lives. WaveDetails lives
 * in the WaveSimModel, which outlives its simulation by design, and a copy of it sits in every
 * model generation React retains - which is how an ended simulation's memory survived every
 * explicit release. Built here, where no closure can capture anything, the comparer retains
 * nothing. Do not inline this into a caller that has a simulation in scope.
 */
export function makeWaveMap(pairs) {
    return ofList_1(pairs, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
}

